// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  enableTransactionSync: false,
  isSandboxBanking: true,
  appInsights: {
    instrumentationKey: '579abcaf-b8a9-4eb9-855d-89bd7296f6c8'
  },
  apiUrl: 'https://simplidivine-staging-app.azurewebsites.net/api',
  googleMapsApiUrl: 'https://maps.googleapis.com/maps/api/js',
  googlePlacesApiUrl: 'https://places.googleapis.com/v1/places',
  googleMapApiKey: 'AIzaSyCZM-WKM7QdPeQ462y9Vgm_dhxVWMMhbM0',
  basePrice: 89.99,
  publicSiteUrl: 'https://staging.simplidivine.com/',
  auth0: {
    domain: 'stg-simplidivine.us.auth0.com',
    clientId: 'vtiZhVrGfU4vykUqymDC5GtjMNWGEFm4',
    audience: 'https://stg-simplidivine-api.com'
  },
  clover:  {
    iFrameUrl: 'https://checkout.sandbox.dev.clover.com/sdk.js',
    eCommPublicToken: 'fe144893ea5c8dce2818ee35c7e2a1de'
  },
  tinyMceLicenseKey: 'qkrkr2ubck15zucupms124zc2zwc883p0rn8tvnj23zqtrdg',
  payrollLink: 'https://www.runpayroll.com/SPF/Login/Auth1.aspx?PC=TVLM'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
